(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glowli-home-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.glowli-home-v2 .photo-choice').forEach(button=>button.addEventListener('click',()=>{const scope=button.closest('.glowli-home-v2');const img=scope.querySelector('.glowli-featured-photo');if(img&&button.dataset.photoUrl){img.removeAttribute('srcset');img.src=button.dataset.photoUrl;img.alt=button.textContent.trim();}scope.querySelectorAll('.photo-choice').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
